import { ReactNode } from 'react';
import { X } from '@phosphor-icons/react';
import { IconButton, Typography } from '@la/ds-ui-components';
import styles from './Alert.module.scss';

export type AlertProps = {
  icon?: ReactNode;
  message: ReactNode | string;
  onClose?: () => void;
};

export function Alert({ icon, message, onClose }: AlertProps) {
  return (
    <div className={styles.alert}>
      <div className={styles.icon}>{icon}</div>
      <Typography variant="ui" size="large">
        {message}
      </Typography>
      {onClose ? (
        <div className={styles.close}>
          <IconButton
            icon={<X fill="var(--black)" size="medium" weight="bold" />}
            onClick={onClose}
            variant="text"
          />
        </div>
      ) : null}
    </div>
  );
}
